// extracted by mini-css-extract-plugin
export default {"container":"AddStorageModal_container__9H8ZC"};